import React, {memo} from "react";
import GaugeChart from "react-gauge-chart";
import { Chip } from "@mui/material";

const chipStyle = {
  color: "#d3f4fe",
  minWidth: "50px",
};

const OutdoorAQIKPI = memo(({ avgAQI, maxAQI, minAQI }) =>
    <>
      <GaugeChart
        id="gauge-chart4"
        animate={false}
        arcsLength={[0.1, 0.1, 0.1, 0.1, 0.2, 0.4]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={avgAQI/ 500}
        hideText={true}
        style={{ width: "110px" }}
        className="dashboard-health-title"
      />
      <span>{avgAQI}</span>
      <p className="card-value">Air Quality</p>
      <div className="d-flex flex-column justify-content-start align-items-start gap-2">
        <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max" sx={chipStyle} />
          <p className="m-1 p-0">{maxAQI}</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Min" sx={chipStyle} />
          <p className="m-1 p-0">{minAQI}</p>
        </div>
      </div>
    </>)

export default OutdoorAQIKPI;
